import { CellContext } from "@tanstack/react-table"

import { AdminMessage, AdminMessageDevice } from "store/api/adminMessagesApi"
import { UITypes } from "types"

import RowExpandToggle from "components/table/columnComponents/RowExpandToggle"
import { StatusOfMessageReport } from "components/table/columnComponents/StatusOfMessageReport"

import { AdminMessageCenterDevice } from "./adminMessageUtils"

import styles from "./index.module.scss"

const MessageContent = ({ cell }: { cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell> }) => {
  const content = cell.getValue().value
  if (!content) return null

  return (
    <details className={styles.messagePreview}>
      <summary>See message</summary>
      <p>{String(content)}</p>
    </details>
  )
}

export const adminMessageTableHeaderCells: UITypes.TableHeaderCell[] = [
  { title: "", size: "mini", name: "group_toggle", cellComponent: RowExpandToggle },
  { title: "", size: "mini", name: "checkbox", type: "checkbox", cellComponent: "checkbox" },
  { title: "Email", size: "middle", name: "email", type: "search" },
  { title: "S/N", size: "middle", name: "thermostat_id", type: "search" },
  { title: "Customer", size: "middle", name: "customer", type: "search" },
  { title: "Contractors", size: "middle", name: "contractor_name", type: "search" },
  { title: "Schedule date", size: "middle", name: "scheduled_at", cellComponent: "datetime" },
  { title: "Delivery date", size: "middle", name: "delivered_at", cellComponent: "datetime" },
  { title: "Status", size: "small", name: "delivery_status", cellComponent: StatusOfMessageReport },
  { title: "Scheduled Message", size: "middle", name: "scheduled_message", cellComponent: MessageContent },
  { title: "Country", size: "small", name: "country" },
]

const emptyDeviceCells = {
  email: { hidden: true },
  thermostat_id: { hidden: true },
  customer: { hidden: true },
  contractor_name: { hidden: true },
  country: { hidden: true },
}

const messageRow = (message: AdminMessage): UITypes.TableBodyRow =>
  ({
    group_toggle: { hidden: true },
    checkbox: { hidden: true },
    ...emptyDeviceCells,
    scheduled_at: { value: message.scheduled_at },
    delivered_at: { value: message.delivered_at },
    delivery_status: { value: message.delivery_status },
    scheduled_message: { value: message.content_plain || message.content_rich || message.title },
    rowSettings: { id: message.id, item: message },
  }) as UITypes.TableBodyRow

type AdminMessageTableDevice = AdminMessageCenterDevice | AdminMessageDevice

export const convertAdminMessageDevicesToTableRows = (
  devices: AdminMessageTableDevice[] = [],
): UITypes.TableBodyRow[] =>
  devices.map(device => {
    const isAdminDevice = "sn" in device

    return {
      group_toggle: { hidden: device.messages.length === 0 },
      checkbox: {},
      email: { value: isAdminDevice ? device.email : device.customer_email },
      thermostat_id: { value: isAdminDevice ? device.sn : device.serial_number },
      customer: { value: isAdminDevice ? device.homeowner : device.customer_name },
      contractor_name: {
        value: isAdminDevice ? device.contractor_name : device.contractor_name || device.contractor_account,
      },
      scheduled_at: {},
      delivered_at: {},
      delivery_status: {},
      scheduled_message: {},
      country: { value: isAdminDevice ? device.country_name : "US" },
      subRows: device.messages.map(messageRow),
      rowSettings: { id: device.id, item: device },
    }
  })
